import PageHelmet from "../../components/pageHelmet";
import Header from "../../components/header";
import HeroSec from "../../components/heroSec";
import KeyOfferingSec from "../../components/keyOfferingSec";
import QuerySec from "../../components/querySec";
import Footer from "../../components/footer";

function Home() {
  return (
    <>
      <PageHelmet title="Welcome to Value 360" />
      <Header />
      <QuerySec
        heading="Say Hello!"
        description="At Value 360, we stay on top of shifting paradigms in the world of communications. As PR evolves, we continue to expand our ambit, focusing on exceeding client expectations at every juncture. We are thrilled to be in Singapore and look forward to unlocking opportunities for your brand. Drop a line – let’s get the ball rolling!"
      />
      <HeroSec
        label="WHO WE ARE?"
        heading="The Most Disruptive Start-up Integrated Communication Firm In Singapore"
        description="With extensive, hands-on experience in building Indian Unicorn brands, Value 360 Communications accelerates your brand’s growth trajectory through its proven integrated communication techniques.Our repertoire of successful partnerships includes marquee names like Paytm, Urban Company, Delhivery, Shopmatic, and Droom. Partner with us to gain a competitive advantage and create maximum impact across platforms."
      />
      <KeyOfferingSec label="OUR OFFERINGS" heading="Key Offerings" />
      <Footer />
    </>
  );
}
export default Home;
